var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Mixins } from 'vue-property-decorator';
import { FilterApplyMode } from '../types';
import BaseTableFilterMixin from './baseFilterMixin';
var FilterKind;
(function (FilterKind) {
    FilterKind["Checkbox"] = "checkbox";
    FilterKind["Radio"] = "radio";
})(FilterKind || (FilterKind = {}));
var ChoiceFilter = /** @class */ (function (_super) {
    __extends(ChoiceFilter, _super);
    function ChoiceFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.FilterKind = FilterKind;
        return _this;
    }
    Object.defineProperty(ChoiceFilter.prototype, "inputValue", {
        get: function () {
            switch (this.options.kind) {
                case FilterKind.Checkbox:
                    return this.value;
                case FilterKind.Radio:
                    return this.value[0];
            }
        },
        set: function (value) {
            switch (this.options.kind) {
                case FilterKind.Checkbox:
                    this.value = value;
                    break;
                case FilterKind.Radio:
                    this.$set(this.value, 0, value);
                    break;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChoiceFilter.prototype, "inputType", {
        get: function () {
            switch (this.options.kind) {
                case FilterKind.Checkbox:
                    return 'checkbox';
                case FilterKind.Radio:
                    return 'radio';
            }
        },
        enumerable: false,
        configurable: true
    });
    ChoiceFilter.prototype.getOptionId = function (value) {
        return "".concat(this.field.name, "_").concat(value);
    };
    ChoiceFilter.prototype.getOptionName = function (value) {
        switch (this.options.kind) {
            case FilterKind.Checkbox:
                return value;
            case FilterKind.Radio:
                return this.field.name;
        }
    };
    ChoiceFilter.prototype.mounted = function () {
        var _this = this;
        if (this.options.mode == FilterApplyMode.OnChange) {
            this.$watch(function () { return [_this.value]; }, this.filter);
        }
    };
    ChoiceFilter = __decorate([
        Component({
            components: {},
        })
    ], ChoiceFilter);
    return ChoiceFilter;
}(Mixins(
// Mixin constructors go here
BaseTableFilterMixin)));
export default ChoiceFilter;
